// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LocationTransportAccessibilityBlock2 .cms-block-stub ol li:before,.LocationTransportAccessibilityBlock2 .cms-block-stub ul li:before{background-color:#0c6198}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
